<template>
  <div class="kw_bottom_window">
    <el-drawer title="我是标题" :visible.sync="shareButtonInfo.ifLoad" :with-header="false"  direction="btt" custom-class="drawerClass" size="15%">
      <div class="view_share_array">
        <img src="./img/bottomImg.jpg" class="shareBackground"/>
        <button @click="toCopyUrl" class="share">复制链接</button>
        <button @click="toImageCanvas" class="feedback">生成海报</button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_bottom_window',
  props: {
    shareButtonInfo:{
      type:Object,
      value:{
        ifLoad:false
      }
    }
  },
  data() {
    return {
    };
  },
  created() {
    this.initAttached();
  },
  mounted() {
    
  },
  watch:{
    "shareButtonInfo.ifLoad":function(newVal){
//      console.log("newVal===============",newVal);
      this.initInfo();
    }
  },
  computed:{
  },
  components: {
  },
  methods: {
    initInfo: function () {
      this.initAttached();
    },
    initAttached: function () {
      var shareButtonInfo = this.shareButtonInfo;
      if (shareButtonInfo.ifLoad) {
        this.showPopup();
      } else {
        this.onClose();
      }
    },
    // 去生成海报信息
    toImageCanvas(){
      this.onClose();
      var shareButtonInfo = this.shareButtonInfo;
      pageUtils.toImageCanvas(this,shareButtonInfo.dataInfo, shareButtonInfo.buttonSet);
    },
    // 底部分享部按钮组
    showPopup() {
      var that = this;
      var shareButtonInfo = this.shareButtonInfo;
      var dataInfo = shareButtonInfo.dataInfo;
      var buttonSet = shareButtonInfo.buttonSet;
      if (buttonSet && buttonSet.styleSet) {
        // 记录操作历史
        if (buttonSet.styleSet.nextOperaType == 7) {
          var toHtData = {};
          toHtData.isInterFace = 1;
          toHtData.tableId = buttonSet.styleSet.clickTableId;
          toHtData.pageId = buttonSet.styleSet.clickPageId;
          toHtData.DATA_ID = dataInfo.LMF_ID;
          var pageRouteInfo = pageUtils.getShareRouteInfo(that);
          toHtData.PAGE_ROUTE = pageRouteInfo.pageRoute;
          toHtData.TABLE_ID = pageRouteInfo.tableId;
          toHtData.PAGE_ID = pageRouteInfo.pageId;
          toHtData.LOOK_DATA_ID = pageRouteInfo.mainId;
          localStorage.shareToHtData = JSON.stringify(toHtData);
        }
      }
    },

    onClose() {
      this.$emit("hideBottom",false);
//      console.log("this.shareButtonInfo==22=",this.shareButtonInfo);
    },
    /**
     * 复制链接地址
     */
    toCopyUrl() {
      var that = this;
      var url = window.location.href;
      var scene = "";
      var pageRouteInfo = pageUtils.getShareRouteInfo(that);
      scene = pageRouteInfo.scene;
      url+="&"+scene;
      var aux = document.createElement("input"); 
      aux.setAttribute("value", url); 
      document.body.appendChild(aux); 
      aux.select();
      document.execCommand("copy"); 
      document.body.removeChild(aux);
      that.$message({
        message: '复制成功!',
        type: 'success'
      });
    }
    
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.view_share_array{display: flex;justify-content: center;align-items: center;width: 100%;height: 100%;position: relative}
.share{font-size: 16px;background: #F93532;color: #ffffff;border: none;margin-right: 10px;height: 30px;line-height: 30px;border-radius: 15px;position: absolute;left:20px}
.feedback{font-size: 16px;background: #FEA940;color: #ffffff;border: none;height: 30px;line-height: 30px;border-radius: 15px;position: absolute;right:20px}
.shareBackground{width: 100%;height: 100%;position: absolute;top: 0;left: 0;}
</style>
<style>
  .kw_bottom_window .drawerClass .el-drawer__header{display: none !important;}
</style>
